module.exports = __webpack_public_path__ + "img/photo_220320572_1.a53dfe42.png";